export class _tbOption{
    position?:string;
    width?:string;
    background?:string;
    bootstrapClass?:string
  }

export class AccessoExagerato{
    user:string="";
    licenzaKey:string="";  
    connesso:boolean=false;    
    loggato:boolean=false;
    lastLicenzaKey:string="";    
}

export class _InfoUtenteConnesso
{
    userName:string;
    nomeCompleto:string;
    codiceFiscale:string;
    telefono:string;
    foto:string;
    ultime3Password:string;
    emailRecupero:string;
    emailComunicazioni:string;
    owner: boolean;
    sospeso: boolean;
    tipoUtente: number;
    accessoConPIN: number;
  }
  export class TemporaryPaste{
    source?:string="";
    type?:string="";
    data?:Array<any>
    paste?:Array<any>
    title?: string;
}

export class AccessToken{
    access_token:string;
    token_type:string;
    expires_in:string;
    idUser:string;    
    userName:string; 
    company:string;   
    stato:string;
    errore:string; 
    foto:string;  
    access_token_rentri:string;     
}

export class Utente {
    logIn:boolean;
    idAccount:string;
    aziendaSelected:number;
    annoSelected:number;
    aziendaSelectedAnnoInstallazione:number;
    userName:string;
    tipoutente:string;
    tipoUtente:number;
    idtipoutente:number;
    nomeCompleto:string;
    codiceFiscale:string;
    telefono:string;
    foto:string;
    emailRecupero:string;
    emailComunicazioni:boolean;
    owner: string;
    ULTIMAAPPLICAZIONE:string;
    licenza:string;
    descr_licenza:string;
    licenze: any;
    aziende:any;
    scadenzaPassword:Date;
    accessoConPIN:number;
    numeroGiorniScadenzaPassword:number;
    scadenzaAccount:Date;
    permessi:any;
}

export class Clienti {
    id: number;
    ragionesociale: string;
    comune: string;
    piva?: string;
    codfis?: string;
    data?: string;
    elemento1?:number;
    elemento2?:number;
    elemento3?:number;
    visible?:boolean=true;
    
  }

  
export class Colonne {
    dataField: string;
    caption: string;
    visible: boolean;
    userLocked: boolean;
    sharpen?:boolean;
}
export class eventGrid {
    type:string;
    index:number;
    key:string;
    selectedRows?:Array<number>
}
// strutture dati
interface Azienda {
    id: number;
    name: string;
}


